// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivityGraph.css */
.activity-graph-page {
    display: flex;
    position: relative;
    min-height: 100vh;
}

/* parameter panel */
.parameter-panel {
    position: relative;
    width: 320px;
    min-height: 100vh;
    background-color: #f8f9fa;
    border-right: 1px solid #dee2e6;
    box-shadow: 2px 0 8px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;
    z-index: 100;
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
}

.parameter-panel.collapsed {
    transform: translateX(-290px);
    overflow-y: hidden;
}

.parameter-panel.collapsed .panel-content {
    opacity: 0;
    pointer-events: none; /* disable interaction */
}

/* sidebar toggle icon */
.panel-toggle {
    position: absolute;
    top: 12px;
    right: 12px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 101;
    padding: 0;
}

.parameter-panel.collapsed .panel-toggle {
    right: 10px;
}

.panel-toggle-icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
}

/* parameter title and add icon */
.panel-content h3 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.add-parameter-btn {
    background: #2ea44f;
    border: 1px solid #2a9146;
    color: white;
    cursor: pointer;
    font-size: 20px;
    display: flex;
    align-items: center;
    padding: 3px 10px;
    margin-left: 10px;
    margin-top: 0;
}

.add-parameter-btn:hover {
    background-color: #2a9146;
}

/* parameter set */
.parameter-set {
    background-color: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    position: relative;
}

.select-wrapper label {
    display: block;
    margin-bottom: 3px;
    font-size: 14px;
    color: #555;
}

.select-wrapper:not(:first-child) label {
    margin-top: 5px;
}

.select-wrapper select {
    width: 100%;
    padding: 7px 7px;
    border: 1px solid #d1d5da;
    border-radius: 6px;
    font-size: 14px;
    background-color: #fff;
}

.remove-set-button {
    position: absolute;
    top: 4px;
    right: 8px;
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    font-size: 16px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    transition: all 0.2s;
}

.remove-set-button:hover {
    background-color: rgba(220, 53, 69, 0.1);
}

/* buttons below panel */
.panel-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.panel-actions button {
    padding: 10px 25px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.clear-btn {
    background-color: #fafbfc;
    border: 1px solid #d1d5da;
    color: #24292e;
}

.clear-btn:hover {
    background-color: #f3f4f6;
}

/* mismatch position note */
.note {
    font-size: 12px;
    color: #666;
    margin-top: 3px;
    font-style: italic;
}

/* no chart message*/
.no-chart-message {
    text-align: center;
    color: #666;
    padding: 40px;
    font-size: 16px;
    grid-column: 1 / -1;
}

/* loading message */
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    color: #666;
}

/* main content */
.activity-graph-main-content {
    margin-right: 30px;
    margin-top: 20px;
    padding-left: 30px;
    padding-bottom: 100px;
    width: calc(100% - 320px);
    transition: margin-left 0.3s ease;
}

.activity-graph-main-content.expanded {
    margin-left: -300px;
    width: calc(100% - 20px);
}

.activity-graph-main-content h1 {
    font-size: 20px;
    display: flex;
    justify-content: center;
    margin: auto;
    color: #333;
    padding-bottom: 15px;
}

/* graph container */
.graph-container {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
}

.graph-card {
    background-color: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    overflow: hidden;
}

.graph-title {
    color: black;
    padding: 12px 15px 0px 20px;
    margin: 0;
    overflow-x: auto;
    overflow-y: hidden;
}

.graph-title-line {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-size: 15px;
    line-height: 1.4;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.graph-title-text {
    white-space: nowrap;
}

.graph-color-chip {
    width: 28px;
    height: 12px;
    border-radius: 2px;
    display: inline-block;
    flex: 0 0 28px;
}

.chart-container {
    height: 400px;
    padding: 0px 15px 15px 15px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ActivityGraph.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,+BAA+B;IAC/B,qCAAqC;IACrC,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,oBAAoB,EAAE,wBAAwB;AAClD;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B","sourcesContent":["/* ActivityGraph.css */\n.activity-graph-page {\n    display: flex;\n    position: relative;\n    min-height: 100vh;\n}\n\n/* parameter panel */\n.parameter-panel {\n    position: relative;\n    width: 320px;\n    min-height: 100vh;\n    background-color: #f8f9fa;\n    border-right: 1px solid #dee2e6;\n    box-shadow: 2px 0 8px rgba(0,0,0,0.1);\n    transition: transform 0.3s ease;\n    z-index: 100;\n    padding: 20px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.parameter-panel.collapsed {\n    transform: translateX(-290px);\n    overflow-y: hidden;\n}\n\n.parameter-panel.collapsed .panel-content {\n    opacity: 0;\n    pointer-events: none; /* disable interaction */\n}\n\n/* sidebar toggle icon */\n.panel-toggle {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    z-index: 101;\n    padding: 0;\n}\n\n.parameter-panel.collapsed .panel-toggle {\n    right: 10px;\n}\n\n.panel-toggle-icon {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n}\n\n/* parameter title and add icon */\n.panel-content h3 {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.add-parameter-btn {\n    background: #2ea44f;\n    border: 1px solid #2a9146;\n    color: white;\n    cursor: pointer;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    padding: 3px 10px;\n    margin-left: 10px;\n    margin-top: 0;\n}\n\n.add-parameter-btn:hover {\n    background-color: #2a9146;\n}\n\n/* parameter set */\n.parameter-set {\n    background-color: #fff;\n    border: 1px solid #e1e4e8;\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 15px;\n    position: relative;\n}\n\n.select-wrapper label {\n    display: block;\n    margin-bottom: 3px;\n    font-size: 14px;\n    color: #555;\n}\n\n.select-wrapper:not(:first-child) label {\n    margin-top: 5px;\n}\n\n.select-wrapper select {\n    width: 100%;\n    padding: 7px 7px;\n    border: 1px solid #d1d5da;\n    border-radius: 6px;\n    font-size: 14px;\n    background-color: #fff;\n}\n\n.remove-set-button {\n    position: absolute;\n    top: 4px;\n    right: 8px;\n    background: none;\n    border: none;\n    color: #dc3545;\n    cursor: pointer;\n    font-size: 16px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border-radius: 50%;\n    transition: all 0.2s;\n}\n\n.remove-set-button:hover {\n    background-color: rgba(220, 53, 69, 0.1);\n}\n\n/* buttons below panel */\n.panel-actions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.panel-actions button {\n    padding: 10px 25px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.clear-btn {\n    background-color: #fafbfc;\n    border: 1px solid #d1d5da;\n    color: #24292e;\n}\n\n.clear-btn:hover {\n    background-color: #f3f4f6;\n}\n\n/* mismatch position note */\n.note {\n    font-size: 12px;\n    color: #666;\n    margin-top: 3px;\n    font-style: italic;\n}\n\n/* no chart message*/\n.no-chart-message {\n    text-align: center;\n    color: #666;\n    padding: 40px;\n    font-size: 16px;\n    grid-column: 1 / -1;\n}\n\n/* loading message */\n.loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    color: #666;\n}\n\n/* main content */\n.activity-graph-main-content {\n    margin-right: 30px;\n    margin-top: 20px;\n    padding-left: 30px;\n    padding-bottom: 100px;\n    width: calc(100% - 320px);\n    transition: margin-left 0.3s ease;\n}\n\n.activity-graph-main-content.expanded {\n    margin-left: -300px;\n    width: calc(100% - 20px);\n}\n\n.activity-graph-main-content h1 {\n    font-size: 20px;\n    display: flex;\n    justify-content: center;\n    margin: auto;\n    color: #333;\n    padding-bottom: 15px;\n}\n\n/* graph container */\n.graph-container {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    width: 100%;\n}\n\n.graph-card {\n    background-color: #fff;\n    border: 1px solid #e1e4e8;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n    overflow: hidden;\n}\n\n.graph-title {\n    color: black;\n    padding: 12px 15px 0px 20px;\n    margin: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.graph-title-line {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 4px;\n    font-size: 15px;\n    line-height: 1.4;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n}\n\n.graph-title-text {\n    white-space: nowrap;\n}\n\n.graph-color-chip {\n    width: 28px;\n    height: 12px;\n    border-radius: 2px;\n    display: inline-block;\n    flex: 0 0 28px;\n}\n\n.chart-container {\n    height: 400px;\n    padding: 0px 15px 15px 15px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
